"use client";

import { ProblemSection } from "@/components/sections/problem";
import { problem } from "@/lib/data/services-competitive-intelligence";

export function Problem() {
  return (
    <ProblemSection
      eyebrow={problem.eyebrow}
      title={problem.title}
      lede={problem.lede}
      accent={problem.accent}
      pillars={problem.pillars}
    />
  );
}